export default __webpack_public_path__ + "static/web_img2-3e3428e1e124550083e16814087e30eb.webp";